module.exports = require("mapbox-gl");